"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prop = exports.props = exports.object = void 0;
var guard_1 = require("../guard");
var helpers_1 = require("../utils/helpers");
/**
 * Construct a type-guard for an `object`
 * @param options.props the properties of the objects as a record of (key, type-guard)
 * @param options.extendable allow additional keys
 * @param options.mask filter off additional keys when coercing
 */
function object(options) {
    var e_1, _a;
    var _b = __assign({ extendable: false, mask: false }, options), extendable = _b.extendable, mask = _b.mask, propsGuards = _b.props;
    var knownKeys = Object.keys(propsGuards).sort();
    try {
        for (var knownKeys_1 = __values(knownKeys), knownKeys_1_1 = knownKeys_1.next(); !knownKeys_1_1.done; knownKeys_1_1 = knownKeys_1.next()) {
            var knownKey = knownKeys_1_1.value;
            var propGuard = propsGuards[knownKey];
            if (propGuard instanceof guard_1.TypeGuard === false) {
                throw new Error("\"properties." + knownKey + "\" must an instance of Guard");
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (knownKeys_1_1 && !knownKeys_1_1.done && (_a = knownKeys_1.return)) _a.call(knownKeys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var schema = Object.freeze({
        type: 'object',
        className: 'Object',
        properties: Object.freeze(Object.entries(propsGuards).reduce(function (acc, _a) {
            var _b;
            var _c = __read(_a, 2), k = _c[0], schema = _c[1].schema;
            return __assign(__assign({}, acc), (_b = {}, _b[k] = schema, _b));
        }, {}))
    });
    return new guard_1.TypeGuard(schema, function (value) {
        if (typeof value === 'object' && value !== null) {
            var castedProps = Object.entries(propsGuards).reduce(function (acc, _a) {
                var _b;
                var _c = __read(_a, 2), k = _c[0], g = _c[1];
                var propValue = value[k];
                return __assign(__assign({}, acc), (_b = {}, _b[k] = g.coerce(propValue), _b));
            }, {});
            return __assign(__assign({}, (mask === true ? {} : value)), castedProps);
        }
        return value;
    }, function (value) {
        var _a, _b, _c, k, g, propValue, _d, _e, _f, path, rest, e_2_1, e_3_1, unknownKeys;
        var e_3, _g, e_2, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (!(typeof value === 'object' && value !== null)) return [3 /*break*/, 17];
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 12, 13, 14]);
                    _a = __values(Object.entries(propsGuards)), _b = _a.next();
                    _j.label = 2;
                case 2:
                    if (!!_b.done) return [3 /*break*/, 11];
                    _c = __read(_b.value, 2), k = _c[0], g = _c[1];
                    propValue = value[k];
                    _j.label = 3;
                case 3:
                    _j.trys.push([3, 8, 9, 10]);
                    _d = (e_2 = void 0, __values(g.validate(propValue))), _e = _d.next();
                    _j.label = 4;
                case 4:
                    if (!!_e.done) return [3 /*break*/, 7];
                    _f = _e.value;
                    path = _f.path, rest = __rest(_f, ["path"]);
                    return [4 /*yield*/, __assign({ path: __spread([k], path) }, rest)];
                case 5:
                    _j.sent();
                    _j.label = 6;
                case 6:
                    _e = _d.next();
                    return [3 /*break*/, 4];
                case 7: return [3 /*break*/, 10];
                case 8:
                    e_2_1 = _j.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 10];
                case 9:
                    try {
                        if (_e && !_e.done && (_h = _d.return)) _h.call(_d);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 10:
                    _b = _a.next();
                    return [3 /*break*/, 2];
                case 11: return [3 /*break*/, 14];
                case 12:
                    e_3_1 = _j.sent();
                    e_3 = { error: e_3_1 };
                    return [3 /*break*/, 14];
                case 13:
                    try {
                        if (_b && !_b.done && (_g = _a.return)) _g.call(_a);
                    }
                    finally { if (e_3) throw e_3.error; }
                    return [7 /*endfinally*/];
                case 14:
                    if (!(extendable !== true)) return [3 /*break*/, 16];
                    unknownKeys = Object.keys(value)
                        .filter(function (key) { return knownKeys.includes(key) === false; })
                        .sort();
                    if (!(unknownKeys.length !== 0)) return [3 /*break*/, 16];
                    return [4 /*yield*/, {
                            path: [],
                            rule: 'extendable',
                            setting: extendable,
                            actual: unknownKeys
                        }];
                case 15:
                    _j.sent();
                    _j.label = 16;
                case 16: return [3 /*break*/, 19];
                case 17: return [4 /*yield*/, {
                        path: [],
                        rule: 'type',
                        setting: 'object',
                        actual: helpers_1.actualTypeOf(value)
                    }];
                case 18:
                    _j.sent();
                    _j.label = 19;
                case 19: return [2 /*return*/];
            }
        });
    });
}
exports.object = object;
/**
 * Construct a type-guard for an `object`
 * @param props the properties of the objects as a record of (key, type-guard)
 */
function props(props) {
    return object({ props: props });
}
exports.props = props;
/**
 * Construct a type-guard for a single-property `object`
 * @param key the key of property
 * @param value the value of property
 */
function prop(key, value) {
    var _a;
    if (['number', 'string', 'symbol'].includes(typeof key) === false) {
        throw new Error('"key" must a number, string or symbol');
    }
    if (value instanceof guard_1.TypeGuard === false) {
        throw new Error('"value" must an instance of Guard');
    }
    return object({
        props: (_a = {}, _a[key] = value, _a)
    });
}
exports.prop = prop;
